"use client";

import React from "react";
import { FileText } from "lucide-react";
import { CompanyInfoCard } from "./CompanyInfoCard";
import { ClampedText } from "@/components/shared/ClampedText";
import type { CompanyEntity } from "@/lib/types/company";

interface CompanyNotesProps {
  company: CompanyEntity;
}

export function CompanyNotes({ company }: CompanyNotesProps) {
  if (!company.notes || typeof company.notes !== "string" || !company.notes.trim()) {
    return null;
  }

  return (
    <CompanyInfoCard title="Notes" icon={FileText} className="col-span-2">
      <div className="prose prose-sm max-w-none">
        <ClampedText
          text={company.notes}
          lines={4}
          className="text-sm text-gray-700 dark:text-gray-300 leading-relaxed"
        />
      </div>
    </CompanyInfoCard>
  );
}
